import _ from "lodash";
/**--external-- */
import React, { useEffect, useState } from "react";
import { Button, Modal, TextInput } from "@toddle-edu/ds-web";
import { RefreshArrowOutlined } from "@toddle-edu/ds-icons";
import { connect } from "react-redux";

/**--internal-- */
import { useI18n } from "Hooks";
import { getUserInfo } from "Login/modules/LoginModule/LoginUtils";

/**--relative-- */
import classes from "./VerifyOtpModal.scss";

const styles = {
  modalBodyStyle: {
    paddingTop: "16px",
  },
};

const OtpInputComp = props => {
  const {
    t,
    timer,
    onSubmit,
    updateInputField,
    inputDetails,
    isResendEnabled,
    handleResendClick,
  } = props;

  const handleKeyPress = e => {
    if (e.key === "Enter") {
      const otpValue = _.get(inputDetails, "otp", "");
      if (!otpValue) {
        return;
      }
      onSubmit();
    }
  };

  const onInputChange = e =>
    updateInputField({ key: "otp", value: e.target.value });

  return (
    <div>
      <TextInput
        dsVersion="2.0"
        size="medium"
        label={t("signin:enter_otp")}
        placeholder={"• • • • • •"}
        value={_.get(inputDetails, "otp")}
        autoFocus={true}
        onChange={onInputChange}
        onKeyPress={handleKeyPress}
      />
      <div className={classes.resendOtpBtnContainer}>
        <Button
          dsVersion="2.0"
          className={classes.resendOtpBtn}
          data-test-id="button-send-again"
          type={"plain"}
          size={"small"}
          tabIndex="-1"
          onClick={handleResendClick}
          disabled={!isResendEnabled}
          icon={<RefreshArrowOutlined />}
        >
          <span className={classes.resendTextWrapper}>{`${t(
            "common:send_again"
          )} ${isResendEnabled ? "" : `(${timer}s)`}`}</span>
        </Button>
      </div>
    </div>
  );
};

const VerifyOtpModal = props => {
  const {
    onInputChange,
    inputDetails,
    onModalClose,
    onSubmit,
    generateEmailOTPForSessionVerification,
    shouldCloseOnOverlayClick = true,
    isClosable = true,
    email,
  } = props;
  const { t } = useI18n();

  const [isResendEnabled, setIsResendEnabled] = useState(false);
  const [timer, setTimer] = useState(_.get(inputDetails, "RESEND_TIMER", 15));
  const [intervalId, setIntervalId] = useState();

  // resets the state and starts the timer
  useEffect(() => {
    resetOTP();
    startTimer();
  }, []);

  // checks timer and enables the resend button
  useEffect(() => {
    if (timer === 0) {
      clearInterval(intervalId);
      setIsResendEnabled(true);
    }
  }, [timer, intervalId]);

  const startTimer = () => {
    const id = setInterval(() => {
      setTimer(prevTimer => prevTimer - 1);
    }, 1000);
    setIntervalId(id);
  };

  const updateInputField = ({ key, value }) => {
    onInputChange({ [key]: value });
  };

  const resetOTP = () => {
    updateInputField({
      key: "otp",
      value: "",
    });
  };

  const handleResendClick = async () => {
    const { isSuccess } = await generateEmailOTPForSessionVerification();
    if (isSuccess) {
      resetOTP();
      setTimer(_.get(inputDetails, "RESEND_TIMER", 15));
      setIsResendEnabled(false);
    }
  };

  return (
    <Modal
      onClose={onModalClose}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      height="352px"
      width="552px"
      dsVersion={"2.0"}
    >
      <Modal.Header
        isClosable={isClosable}
        title={t("signin:verify_email_address")}
        subtitle={t("signin:otp_sent_to_email", {
          email,
        })}
        dsVersion={"2.0"}
      />
      <Modal.Body dsVersion={"2.0"} style={styles.modalBodyStyle}>
        <OtpInputComp
          t={t}
          timer={timer}
          inputDetails={inputDetails}
          isResendEnabled={isResendEnabled}
          updateInputField={updateInputField}
          handleResendClick={handleResendClick}
          onSubmit={onSubmit}
        />
      </Modal.Body>
      <Modal.Footer dsVersion={"2.0"}>
        <div className={classes.footer}>
          <Button
            dsVersion="2.0"
            onClick={onSubmit}
            disabled={_.isEmpty(_.get(inputDetails, "otp"))}
            variant="progressive"
            shortcut={{ code: "Enter", shiftKey: true }}
          >
            {t("common:verify")}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

const mapActionCreators = {};

const mapStateToProps = state => {
  const userInfo = getUserInfo();
  return {
    email: _.get(userInfo, "email"),
  };
};

export default connect(mapStateToProps, mapActionCreators)(VerifyOtpModal);
